import React from "react";
import {BasketContext} from '../providers';

function useBasket() {
    return React.useContext(BasketContext);
}

function useBasketCo() {
    let count = React.useContext(BasketContext);
    return count.length;
}

export {useBasket,useBasketCo}
